
<ng-container *ngIf="!isOptionLoading;else Loading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID" [title]="'綁定會員'"></app-nav-header> 
      <ng-container *ngIf="!isOptionLoading;else Optionloading">
        <div [ngSwitch]="Step">
          <div *ngSwitchCase="1">
              <form class="page__content pageForm">
                <div class="grid p-fluid row">
                  <!-- 姓名 -->
                  <div class="field">
                    <label starSign class="col-sm-3 notice" for="Name">姓名:</label>
                    <input type="text" class="form-control" placeholder="請輸入姓名" name="Name" [(ngModel)]="User.Name" required>
                  </div>
                  <!-- 手機號碼 -->
                  <div class="field mt-2">
                    <label starSign class="col-sm-3 notice" for="Telephone">手機號碼:</label>
                    <input type="text" class="form-control" placeholder="請輸入手機號碼" name="Telephone" [(ngModel)]="User.Telephone" (blur)="CheckPhone()" required>
                  </div>
                  <div class="field mt-2">
                    <p-message *ngIf="IsErr"  severity="error" text="請輸入合法手機號碼"></p-message>
                  </div>
                  <div class="field mt-2">
                    <app-button appClass="pageForm__btn d-block text-center text-white w-100" (appClick)="nextStep()" appLabel="下一步" [loading]="isLoading" [disabled]="isLoading || IsErr"></app-button>
                  </div>
                </div>
              </form>
          </div>
          <div *ngSwitchCase="2">
            <form class="page__content pageForm">
              <div class="grid p-fluid row">
                <!-- 性別 -->
                <div class="field">
                  <label class="col-3" for="Gender">性別:</label>
                  <p-dropdown *ngIf="GenderList != null" [options]="GenderList" [(ngModel)]="User.Gender" placeholder="請選擇" optionLabel="label"  optionValue="value" [showClear]="true" [ngModelOptions]="{standalone: true}"></p-dropdown>
                </div>
                <!-- 生日 -->
                <div class="field mt-1">
                  <label starSign class="col-sm-3" for="Birthday">生日:</label>
                  <p-calendar [(ngModel)]="User.Birthday" [touchUI]="true" [readonlyInput]="true" inputId="touchui" name="Birthday" dataType="string" dateFormat="yy-mm-dd"></p-calendar>
                </div>
                <!-- Email -->
                <div class="field mt-1">
                  <label starSign class="col-sm-3" for="Email">Email:</label>
                  <input type="email" class="form-control" placeholder="請輸入Email" name="Email" [(ngModel)]="User.Email" required>
                </div>
                <!-- 地址 -->
                <div class="field mt-1">
                  <label starSign class="col-sm-3" for="Address">地址:</label>
                  <p-dropdown *ngIf="CityList != null" [options]="CityList" [(ngModel)]="User.Add1" placeholder="請選擇" appendTo="body" [ngModelOptions]="{standalone: true}" (ngModelChange)="selectCity()"></p-dropdown>
                  <p-dropdown *ngIf="SectionList != null" [options]="SectionList" [(ngModel)]="User.Add2" placeholder="請選擇" appendTo="body" [ngModelOptions]="{standalone: true}"></p-dropdown>
                  <input type="text" class="col-12 mt-2 form-control" name="Add3" [(ngModel)]="User.Add3" placeholder="請輸入地址" required>
                </div>
                <!-- 寵物名 -->
                <div class="field mt-1">
                  <label starSign class="col-sm-3 notice" for="PetName">寵物名稱:</label>
                  <input type="text" class="form-control" placeholder="請輸入寵物名稱" name="PetName" [(ngModel)]="User.PetName" required>
                </div>
                <!-- 寵物性別 -->
                <div class="field mt-1">
                  <label starSign class="col-sm-3" for="PetGender">寵物性別:</label>
                  <p-dropdown *ngIf="GenderList != null" [options]="GenderList" [(ngModel)]="User.PetGender" placeholder="請選擇" optionLabel="label"  optionValue="value" [showClear]="true" [ngModelOptions]="{standalone: true}"></p-dropdown>
                </div>
                <!-- 寵物類型 -->
                <div class="field mt-1">
                  <label starSign class="col-sm-3 notice" for="VarietyType">寵物類型:</label>
                  <p-dropdown *ngIf="VarietyTypeList != null" [options]="VarietyTypeList" [(ngModel)]="User.VarietyType" placeholder="請選擇" appendTo="body" [showClear]="true" [ngModelOptions]="{standalone: true}" (ngModelChange)="SelectVarietyType()"></p-dropdown>
                </div>
                <!-- 寵物品種 -->
                <div class="field mt-1">
                  <label starSign class="col-sm-3 notice" for="Variety">寵物品種:</label>
                  <p-dropdown *ngIf="VarietyList != null" [options]="VarietyList" [(ngModel)]="User.Variety" placeholder="請選擇" appendTo="body" optionLabel="label" [filter]="true" filterBy="label" [showClear]="true" [ngModelOptions]="{standalone: true}"></p-dropdown>
                </div>
                <div class="field mt-1">
                  <app-button appClass="pageForm__btn d-block text-center text-white mt-2 w-100" (appClick)="prevStep()" appLabel="上一步" [loading]="isLoading"></app-button>
                </div>
                <div class="field mt-1">
                  <app-button appClass="pageForm__btn d-block text-center text-white mt-2 w-100" (appClick)="nextStep()" appLabel="下一步" [loading]="isLoading" [disabled]="!EditRequired()"></app-button>
                </div>
              </div>
            </form>
          </div>
          <div *ngSwitchCase="3">
            <div class="page__content pageForm" style="min-width: 90%;">
              <div class="row">
                <ng-container *ngIf="IsMember;else Binding">
                  <div class="col-12">
                    <p>{{User.Name}}，已綁定</p>
                    <p>頁面5秒後進行導頁....</p>
                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
                  </div>
                </ng-container>
                <ng-template #Binding>
                  <div class="col-12">
                    <p>恭禧{{User.Name}}，會員綁定成功</p>
                    <p>頁面5秒後進行導頁....</p>
                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #Optionloading>
        <form class="page__content pageForm" style="width: 350px;text-align: center;">
          <div class="row">
            <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </div>
        </form>
      </ng-template>
   </ng-container>
<ng-template #Loading>
<p-progressSpinner ariaLabel="loading" />
</ng-template>